import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap, switchMap } from "rxjs/operators";

import { V2AdminService } from "../../../services/api/v2-admin.service";
import { ConsumerDistributionKeysActions } from "../../actions/consumer-distribution-keys.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerDistributionKeysEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerDistributionKeysActions.get),
			switchMap(({ consumerId }) =>
				of(ConsumerDistributionKeysActions.getApi({ consumerId }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerDistributionKeysActions.getApi),
			switchMap(({ consumerId }) =>
				this.service.getConsumerDistributionKeys(consumerId).pipe(
					map((keys) =>
						ConsumerDistributionKeysActions.getSuccess({ consumerId, keys })
					),
					catchError((error) =>
						of(
							ConsumerDistributionKeysActions.getFail({
								consumerId,
								error: new FailState(error)
							})
						)
					)
				)
			)
		)
	);

	create = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerDistributionKeysActions.create),
			mergeMap(({ consumerId, udlGroupName, dataDestinationIds }) =>
				this.service
					.createConsumerDistributionKey(consumerId, udlGroupName, dataDestinationIds)
					.pipe(
						map((key) =>
							ConsumerDistributionKeysActions.createSuccess({ consumerId, key })
						),
						catchError((error) =>
							of(
								ConsumerDistributionKeysActions.createFail({
									consumerId,
									error: new FailState(error)
								})
							)
						)
					)
			)
		)
	);

	update = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerDistributionKeysActions.update),
			mergeMap(({ consumerId, distributionKeyId, dataDestinationIds }) =>
				this.service
					.updateConsumerDistributionKey(consumerId, distributionKeyId, dataDestinationIds)
					.pipe(
						map((key) =>
							ConsumerDistributionKeysActions.updateSuccess({ consumerId, key })
						),
						catchError((error) =>
							of(
								ConsumerDistributionKeysActions.updateFail({
									consumerId,
									distributionKeyId,
									error: new FailState(error)
								})
							)
						)
					)
			)
		)
	);

	constructor(
		private actions: Actions,
		private service: V2AdminService
	) {}
}
